module.exports = __webpack_public_path__ + "img/Setting.1985606c.svg";